import React from "react";
import { createRoot } from "react-dom";
import "./whatevs/index.css";
import App from "./App.Combobox";

createRoot(document.getElementById("root")).render(<App />);



// WEBPACK FOOTER //
// ./src/index.js